import { LogService } from './../services/log.service';
import { Injectable } from '@angular/core';
import { tap, catchError, timeout } from 'rxjs/operators';
import { of, Observable, throwError, TimeoutError } from 'rxjs';
import { StorageService } from '@ildes/services/storage-service.service';
import { ToastService } from '@ildes/services/toast.service';
import { environment } from '../../environments/environment';

const HOST = environment.host;
const PORT = environment.port;

import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  private notified = {};
  constructor(
    private log: LogService,
    private storage: StorageService,
    private toastService: ToastService
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<any> {

    const cache = req.headers.get('cache') === 'true';
    const customTimeout = req.headers.get('timeout');

    // if (!req.headers.has('cache') || !cache) {
    //   return next.handle(req);
    // }

    if (req.url.indexOf(HOST)<0) {
      return next.handle(req);
    }
    const headers = req.headers.delete('cache').delete('timeout');
    const [,endpoint] = req.urlWithParams.split(`${HOST}:${PORT}/`);
    const key = btoa(endpoint);
    const data = this.storage.getItem(key, true);
    
    if (!cache) {
      return next.handle(req).pipe(
        customTimeout ? timeout(parseInt(customTimeout)): tap(() => {}),
        tap((response: any) => {
          if (!(response instanceof HttpResponse)) {
            return;
          }
          if (data) {
            try {
                
              this.storage.setItem(key, response.body);
            } catch(e) {
              this.toastService.show(`No dispone de almacenamiento. Limpie datos de la aplicación.`, 'warning');
            }
          }
        }),
        catchError((e: any) => {
            // tratamos como timeout el 401, así si refrescamos datos y tras caducar la sesión, no perdemos datos 
          const isTimeout = e.status === 0 || e.status === 401 || e.status === 402 ||(e instanceof TimeoutError);

          if (!data || !isTimeout) {
            return throwError(e);
          }
          this.toastService.show(`Datos actualizados por última vez ${new Date(data.metadata.timestamp).toLocaleString()}`, 'warning');
          return of(new HttpResponse({
            status: 200,
            body: {...data.value, fromCache: true},
            headers: new HttpHeaders(data.headers || {}).set('X-timeout', 'true')
          }));
        })
      );
    }

    if (data) {
      if (!this.notified[key]) {
        this.toastService.show(`Datos actualizados por última vez ${new Date(data.metadata.timestamp).toLocaleString()}`, 'warning');
      }
      this.notified[key] = true;
      return of(new HttpResponse({
        status: 200,
        body: {...data.value, fromCache: true},
        headers: new HttpHeaders().set('X-cache', 'true')
      }));
    }

    return next.handle(req.clone({ headers })).pipe(
      customTimeout ? timeout(parseInt(customTimeout)): tap(() => {}),
      tap((response) => {
        if (!(response instanceof HttpResponse)) {
          return;
        }
        this.storage.setItem(key, response.body)
      })
    );
  }
}
